<template>
    <div class="row">
        <div class="col-12">
            <table class="table table-bordered table-sm">
                <tbody>
                    <tr>
                        <th class="w-50">Tarih</th>
                        <td class="w-50 font-weight-bolder text-primary">
                            {{currentDate}}
                        </td>
                    </tr>
                    <tr>
                        <th class="w-50">Personel</th>
                        <td class="w-50">
                            {{$safe(value,'Driver.Employee.FirstName') &&  $safe(value,'Driver.Employee.LastName') ? [$safe(value,'Driver.Employee.FirstName'),$safe(value,'Driver.Employee.LastName')].join(' ') : $safe(value,"Driver.DriverFullName")}}
                        </td>
                    </tr>
                    
                </tbody>
            </table>
        </div>
        <div class="col-12">
            <table class="table table-bordered table-sm">
                <tbody>
                    <tr>
                        <th class="w-50">Günlük</th>
                        <td class="w-50" :class="getColor(value.Day.DailyCheckStatus.Type.Code)">{{value.Day.DailyCheckStatus.Type.Code || "-"}}</td>
                    </tr>
                    <tr>
                        <th class="w-50">Maaşa Esas Puantaj</th>
                        <td class="w-50" :class="getColor(value.Day.Score.Type.Code)">{{value.Day.Score.Type.Code || "-"}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-12 mb-1">
            <label class="form-label">Durum</label>
            <select class="form-control" :disabled="value.Locked" v-model="value.Day.Score.Type.Code" v-on:change="getEksikGun">
                <option :value="null">Seçiniz</option>
                <option v-for="type in types" :key="type.Code" :value="type.Code">{{type.Name}}</option>
            </select>
        </div>
        <div class="col-12 mb-1" v-if="value.Day.Score.Type.Code == 'N'">
            <b-form-checkbox :disabled="value.IsGTM || value.Locked" class="mb-50" v-model="value.IsHTM">Hafta Tatili Mesasi</b-form-checkbox>
            <b-form-checkbox :disabled="value.IsHTM || value.Locked" v-model="value.IsGTM">Genel Tatil Mesasi</b-form-checkbox>
        </div>
        <div class="col-md-12 mb-1" v-if="(eksikGuns || []).length != 0">
            <label class="form-label">Eksik Gün</label>
            <v-select-list  :options="eksikGuns" label="Name" append-to-body :disabled="((eksikGuns || []).length <= 1) || value.Locked" placeholder="Eksik Gün" v-model="eksikGun"></v-select-list>
        </div>
        <template v-if="value.Day.Score.Type.Code == 'N' || value.Day.Score.Type.Code == 'Y' /*|| value.Day.Score.Type.Code == 'H' || value.Day.Score.Type.Code == 'RT'*/">
            <div class="col-md-12 mb-1">
                <label class="form-label">Çalışma Süresi</label>
                <v-date-picker :disabled="value.Locked" v-model="value.WorkedTime" type="time" with-seconds placeholder="Çalışma Süresi"></v-date-picker>
            </div>
            <!-- <div class="col-md-12 mb-1" v-if="value.Holiday && value.Day.Score.Type.Code == 'N'">
                <label class="form-label">Resmi Tatil Mesaisi</label>
                <v-date-picker v-model="value.GTM" type="time" with-seconds placeholder="Resmi Tatil Mesaisi"></v-date-picker>
            </div> -->
        </template>
    </div>
</template>

<script>
import moment from 'moment'
import { BFormCheckbox } from 'bootstrap-vue';
import HumanResourcesParametersApi from '@/api/human-resources-parameters';

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        types:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        return {
            eksikGuns:[]
        }
    },
    watch:{
        "value.Day.Score.Type.Code"(){
            this.value.GTM = null
            //this.value.SGKEksikGunId = null
        },
        "value.IsGTM"(){
            this.value.IsHTM = false
        },
        "value.IsHTM"(){
            this.value.IsGTM = false
        },
    },
    mounted(){
        this.getEksikGun()
    },
    methods:{
        getColor(type){
            let color = this.types.find(t=> t.Code == type)?.Color || null
            return color ? `type-${color}` : null
        },
        getEksikGun(){
            if(this.value.Day.Score.Type.Code){
                this.value.SGKEksikGunId = null
                HumanResourcesParametersApi.SGKEksikGun.ListByWorkingType(this.value.Day.Score.Type.Code).then(res => {
                    this.$set(this,'eksikGuns',(res.data.Data || []).map(e=>({
                    ...e,
                    Name:`${e.Code} - ${e.Name}`
                    })).sort((a,b)=> a.Code - b.Code))
                    if(this.eksikGuns.length == 1){
                        this.eksikGun = this.eksikGuns[0]
                    }
                })
                // const type = this.types.find(t=> t.Code == this.value.Day.Score.Type.Code) || null
                // if(type){
                //     const code = type.TIP +""+ type.SIRA_NO
                //     EmployeeOperationApi.Score.EksikGunByKykm(code).then(res=>{
                //         this.$set(this,'eksikGuns',(res.data.Data || []).map(e=>({
                //                             ...e,
                //                             Name:`${e.GRUP_KOD} - ${e.GRUP_ISIM}`
                //                             })).sort((a,b)=> Number(a.GRUP_KOD) - Number(b.GRUP_KOD)))
                //                             console.log(this.eksikGuns)
                //                                 if(this.eksikGuns.length == 1){
                //                                     this.eksikGun = this.eksikGuns[0]
                //                                 }
                //                             })
                // }
            }
        }
    },
    computed:{
        currentDate(){
            return this.value?.Day?.Date ? moment(this.value.Day.Date,'DD.MM.YYYY').locale('tr').format('DD.MM.YYYY dddd') : "-" 
        },
        eksikGun:{
            get:function(){
                return this.eksikGuns.find(s=>s.Id==this.value.SGKEksikGunId)
            },
            set:function(value){
                this.value.SGKEksikGunId = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>